export default __webpack_public_path__ + "static/media/AltCopy.209b0249.svg";